module.exports = __webpack_public_path__ + "img/376794.53be1092.svg";